(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swatch"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__swatchFallbackInit) return;
    window.__swatchFallbackInit = true;

    const tryFallback = (el) => {
      const src1 = el.getAttribute('data-swatch-fallback-src-1');
      const src2 = el.getAttribute('data-swatch-fallback-src-2');
      if (!src1) return;

      const probe = (src, next) => {
        const img = new Image();
        img.onload = () => {
          el.style.setProperty('--swatch-background', `url(${src})`);
          el.classList.remove('swatch--fallback-pending');
        };
        img.onerror = () => {
          if (next) {
            next();
          } else {
            el.classList.remove('swatch--fallback-pending');
            el.classList.add('swatch--unavailable');
          }
        };
        img.src = src;
      };

      probe(src1, () => probe(src2, null));
    };

    const scan = (root) => {
      root.querySelectorAll('[data-swatch-fallback-src-1]').forEach(tryFallback);
    };

    scan(document);

    // Re-scan when Shopify re-renders sections (filtering, search, quick
    // add, etc.) or when new swatches are otherwise injected into the DOM.
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches?.('[data-swatch-fallback-src-1]')) tryFallback(node);
            node.querySelectorAll?.('[data-swatch-fallback-src-1]').forEach(tryFallback);
          }
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
